"use strict";

import { addTimesToResponse } from "../../utils/videoTimes";

export default class UpdatesListCtrl {
  static get UID() {
    return "updatesListCtrl";
  }

  constructor(updateFac, $state, $stateParams, $scope, $filter) {
    Object.assign(this, { updateFac, $state, $stateParams, $scope, $filter });

    this.videos = {};

    this.curPage = parseInt($stateParams.pageNum, 10) || 1;

    this.updateFac.getUpdates(0).then(response => {
      this.videos = addTimesToResponse(response, this.$filter);
    });

    this.$scope.pager = this.pager;
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/updatesList/updatesListCtrl.js